import { ErrorPage } from '@launcher/components/ErrorPage';
import * as Sentry from '@sentry/react';

export const ErrorProvider = ({ children }: { children: React.ReactNode }) => (
  <Sentry.ErrorBoundary fallback={({ error }) => <ErrorPage error={error} />}>
    {children}
  </Sentry.ErrorBoundary>
);
